if (!customElements.get('base-sticky-atc')) {
  customElements.define(
    'base-sticky-atc',
    class BaseStickyAtc extends HTMLElement {
      connectedCallback() {
        this.setupScrollButton();

        if (this.dataset.displayWhen === 'always') {
          this.setAttribute('data-visible', 'true');
          return;
        }

        this.watchBuyButtons();
      }

      /**
       * Alvo do scroll, em ordem de preferência.
       *
       * O seletor do customizer vem primeiro, mas ele não pode ser a única
       * aposta: o id do bloco de informações do produto no Dawn carrega o id da
       * section (ProductInfo-template--000000__main), então um "#ProductInfo"
       * escrito à mão nunca encontra nada — e o botão vira um clique morto, sem
       * erro no console. A cadeia abaixo cai em classes, que o Dawn mantém
       * estáveis.
       */
      findScrollTarget(selector) {
        const candidatos = [selector, '[id^="ProductInfo"]', '.product__info-container', '.product-form__buttons'];

        for (const candidato of candidatos) {
          if (!candidato) continue;
          try {
            const alvo = document.querySelector(candidato);
            if (alvo) return alvo;
          } catch (erro) {
            // seletor inválido digitado no customizer: ignora e tenta o próximo
          }
        }

        return null;
      }

      setupScrollButton() {
        const button = this.querySelector('[data-scroll-target]');
        if (!button) return;

        button.addEventListener('click', () => {
          const target = this.findScrollTarget(button.dataset.scrollTarget);
          if (!target) return;

          // O header do Dawn é sticky e cobriria o topo do alvo. Descontamos a
          // altura real dele em vez de um número mágico, que erraria assim que
          // a barra de comunicados ou o logo mudassem de tamanho.
          const header = document.querySelector('.shopify-section-header-sticky, sticky-header, .section-header');
          const recuo = (header?.offsetHeight || 0) + 16;
          const destino = target.getBoundingClientRect().top + window.scrollY - recuo;

          // Rolagem sempre suave. Levar em salto tira a referência de onde a
          // página estava e de para onde foi — quem clica perde o contexto e
          // precisa reconstruir a tela toda. É movimento de navegação, provocado
          // pelo clique, não enfeite: não fica atrás do prefers-reduced-motion.
          window.scrollTo({ top: Math.max(0, destino), behavior: 'smooth' });

          // Foca o seletor de variante para quem navega por teclado não
          // precisar caçar onde a página parou.
          const focusable = target.querySelector('select, input[type="radio"], button');
          focusable?.focus({ preventScroll: true });
        });
      }

      /**
       * A barra aparece quando o botão de compra da página sai de vista.
       * Observamos o botão real em vez de um offset em pixels: funciona igual
       * em qualquer altura de tela e com qualquer ordem de blocos.
       */
      watchBuyButtons() {
        const buyButtons = document.querySelector('.product-form__buttons');

        if (!buyButtons || !('IntersectionObserver' in window)) {
          this.setAttribute('data-visible', 'true');
          return;
        }

        this.observer = new IntersectionObserver(
          ([entry]) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggleAttribute('data-visible', passed);
          },
          { threshold: 0 }
        );

        this.observer.observe(buyButtons);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
